import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { TableCell, TableRow } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';

export const ContractItemDetailComponent = ({ t, contractLiteDetail }) => {
  return (
    <TableRow>
      <TableCell>
        <span>{contractLiteDetail.itemName}</span>
      </TableCell>
      <TableCell>
        <span>{contractLiteDetail.brand}</span>
      </TableCell>
      <TableCell>
        <span>{contractLiteDetail.model}</span>
      </TableCell>
      <TableCell>
        <span>{contractLiteDetail.version}</span>
      </TableCell>
      <TableCell>
        <ThemedTypography color='info'>{`${t('NUMBER', { number: contractLiteDetail.amountWithTax })} ${
          contractLiteDetail.currencyCode
        }`}</ThemedTypography>
      </TableCell>
      <TableCell>
        <span>{contractLiteDetail.chassisNumber}</span>
      </TableCell>
      <TableCell>
        <span>{contractLiteDetail.dealerName}</span>
      </TableCell>
    </TableRow>
  );
};

ContractItemDetailComponent.propTypes = {
  t: PropTypes.func.isRequired,
  contractLiteDetail: PropTypes.object.isRequired
};

export default compose(withTranslation())(ContractItemDetailComponent);
